export {keywords}

const keywords = [
    "if","если","then","тогда","elsif","иначе", "если","else","иначе","endif",
    "конец", "если", "do","цикл","for","для",
        "to","по","each","каждого","in",
        "из","while","пока","enddo","конеццикла",
        "procedure","процедура","end", "procedure","конецпроцедуры", 
        "function","функция","endfunction","конецфункции", 
        "var","перем","export","экспорт","goto","КонецФункции",
        "перейти","and","и","or","или","not", 
        "не","val","знач","break","прервать",
        "continue","продолжить","return","endtry", 
        "конецпопытки","raise","вызватьисключение","false", 
        "ложь","true","истина","switch","переключатель",
        "case","вариант","default","поумолчанию","endcase",
        "конецварианта","auto","авто","autoend","конецавто",
        "null","null","new","новый","executeshell",
        "выполнить", "команду", "шелла","break", "point","точка", "входа",
        "execute", "report","выполнить", "отчет","execute","выполнить", 
        "форма","form","common","общий","globals",
        "глобальные","constants","константы","endexecutereport", 
        "конец", "выполнить", "отчет","endswitch","конец", "переключателя","resume", 
        "продолжить выполнение","запрос","query","as","как",
        "exit","выйти","message","сообщение","warnings", "конецесли",
        "предупреждения","template","шаблон","lock","блокировка",
        "endlock","конецблокировки","forxml","дляxml","foreachxml",
        "для", "каждого", "поля", "xml","executequery","выполнитьзапрос","endquery", 
        "конец", "запроса","inext","в цикле","iinext","и в цикле",
        "procedure", "export","экспорт", "процедуры","function", "export","экспортфункции", 
        "returns","возвратить","end", "returns","конец", "возвратить", "возврат",
        "object","объект","end", "object","конец", "объекта","remote",',','=','.', '(', ')', '>', '<'  
  ]
